import * as types from './types';

export const pageLoading = (loading) => ({
    type: types.PAGE_LOADING,
    loading
});